import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { fetchUserAccess } from "../thunks/user-thunk";

const userSlice = createSlice({
    name: "user",
    initialState: {
        userAccessList: [],
        userAccessLoaded: false,
        userAccessLoading: false,
    },
    reducers: {
        setUserAccessList(state, action) {
            state.userAccessList = action.payload;
            state.userAccessLoaded = true;
        },
        upsertUserAccess(state, action) {
            const userAccess = action.payload;
            const userAccessId = userAccess?.id ?? userAccess?.userAccessId;
            const index = state.userAccessList.findIndex(
                (item) => String(item?.id ?? item?.userAccessId) === String(userAccessId)
            );
            if (index >= 0) state.userAccessList[index] = userAccess;
            else state.userAccessList.push(userAccess);
            state.userAccessLoaded = true;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchUserAccess.pending, (state) => {
                state.userAccessLoading = true;
            })
            .addCase(fetchUserAccess.fulfilled, (state, action) => {
                state.userAccessList = Array.isArray(action.payload) ? action.payload : [];
                state.userAccessLoaded = true;
                state.userAccessLoading = false;
            })
            .addCase(fetchUserAccess.rejected, (state) => {
                state.userAccessLoaded = true;
                state.userAccessLoading = false;
            });
    },
});

const userSliceName = userSlice.name;
const userReducer = userSlice.reducer;
const useUserStore = () => useSelector((state)=> state.user);
export const {
    setUserAccessList,
    upsertUserAccess
} = userSlice.actions;

export {
    userSliceName,
    userReducer,
    useUserStore,
    fetchUserAccess
};
